import { render, staticRenderFns } from "./MarketInvoicesTableSender.vue?vue&type=template&id=71ef1608&"
import script from "./MarketInvoicesTableSender.vue?vue&type=script&lang=js&"
export * from "./MarketInvoicesTableSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports